import * as r from "react";
import c from "../lib/IconBase.es.js";
import a from "../defs/ArrowCircleLeft.es.js";
const e = r.forwardRef((o, t) => /* @__PURE__ */ r.createElement(c, { ref: t, ...o, weights: a }));
e.displayName = "ArrowCircleLeftIcon";
const m = e;
export {
  m as ArrowCircleLeft,
  e as ArrowCircleLeftIcon
};
